<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-09 17:28:10
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:07:39
 * @Description: file content
 -->

<template>
  <div class="container">
    <BlockTitle :initName="'我也要获客'"></BlockTitle>
    <div class="btn" @click="clickStartUsing">立即使用</div>
    <div class="content">很多客—领先的AI获客神器，{{count}}人正在使用，包括12位您的好友，很多客内置多种裂变获客工具，还有AI助理帮你找客户</div>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="showImg2.isShow=false"></ShowImg2>
  </div>
</template>

<script>
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { mapState, mapMutations } from "vuex";
const BlockTitle = () => import("@/components/block-title");
const ShowImg2 = () => import("@/components/showimg2");

export default {
  components: {
    BlockTitle,
    ShowImg2
  },
  props: {},
  data() {
    return {
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      count: 0
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ])
  },
  methods: {
    clickStartUsing() {
      const that = this;
      if (that.isInMiniProgram) {
        // 点击这个按钮的时候说明是在小程序内部，所以跳转不需要参数
        wxsdk.wx.miniProgram.switchTab({
          url: `/pages/hdk/intro/intro`
        });
      } else {
        util.checkMapStateCallback(this, ["cardInfo"]).then(() => {
          comreq.wxAcode(that, "pages/hdk/intro/intro").then(function(data) {
            if (data) {
              that.showImg2 = {
                url: data,
                width: "50%",
                intro: "扫码，免费获取AI获客神器！",
                isShow: true
              };
            } else {
            }
          });
        });
      }
    }
  },
  created() {
    this.count = util.randomNum(100000, 250000);
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.container {
  position: relative;
  margin-bottom: 0.5rem;
}
.btn {
  position: absolute;
  top: 10px;
  right: 20px;
  width: 1.5rem;
  height: 0.4rem;
  line-height: 0.4rem;
  border-radius: 0.35rem;
  color: #f46263;
  border: 1px solid #f46263;
  text-align: center;
  font-size: 14px;
}
.content {
  font-size: 12px;
  padding: 0 10px;
  line-height: 20px;
}
</style>